import { isSessionStorageAvailable } from '@/utils/utils';
import { useState, useEffect } from 'react';

export function useSessionStorage<T>(key: string, defaultValue: T) {
  const [storedValue, setStoredValue] = useState<T>(() => {
    if (!isSessionStorageAvailable) return defaultValue;

    const item = sessionStorage.getItem(key);
    return item ? JSON.parse(item) : defaultValue;
  });

  useEffect(() => {
    if (isSessionStorageAvailable) {
      sessionStorage.setItem(key, JSON.stringify(storedValue));
    }
  }, [key, storedValue]);

  return [storedValue, setStoredValue] as const;
}
